import React from "react"

import { Loading } from "./loading"

import "../../style/full-body-loader.module.css"

interface Props {
  loading: boolean
}

const FullBodyLoader = (props: Props) => {

  if (!props.loading) {
    return <></>
  }

  return (
    <div className="full-body-loader">
      <Loading />
    </div>
  )
}

export default FullBodyLoader
